import { Component, Input } from '@angular/core';
import { BlobType, FileModel } from '@ca/core/models';
import { environment } from '@ca/environment/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
})
export class FileUploadDialogComponent {
    /**
     * A base 64 string of an image which will automatically be uploaded to our blob storage
     */
    @Input() base64StringToUpload?: string;
    @Input() showButtonBar: boolean = false;
    @Input() maxInputSizeInBytes: number = environment.defaultMaxFileSizeInBytes;
    @Input() pathToAppend?: string;
    @Input() blobType: BlobType = BlobType.UserFile;

    /**
     * Image url which points to the uploaded file (on our blob storage)
     */
    imageUrl?: string;

    constructor(private activeModal: NgbActiveModal) {}

    fileSuccessfullyUploaded(file: FileModel): void {
        this.imageUrl = file.token;

        // if we don't have buttons, close dialog automatically when upload is successful
        if (this.imageUrl != null && !this.showButtonBar) {
            this.closeModal();
        }
    }

    closeModal(): void {
        this.activeModal.close(this.imageUrl);
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }
}
